module.exports = __webpack_public_path__ + "static/media/universe-wordmark-white.3223abd0.svg";